export default "./images/survio-3bIl1-assets-folder-closed-24.svg";